import {createSinglePathSVG} from './TEMPLATE'

export const Italic_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M15.8333 3.33333H8.33333M11.6667 16.6667H4.16667M12.5 3.33333L7.5 16.6667',
})
